// src/auth/AuthContext.jsx
import { createContext, useContext, useEffect, useMemo, useState } from "react";
import api from "./api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [loading, setLoading] = useState(true);
  const [token, setToken] = useState(null);
  const [user, setUser]   = useState(null);

  // Inicializa desde localStorage una sola vez
  useEffect(() => {
    try {
      const t = localStorage.getItem("token");
      const uRaw = localStorage.getItem("user");
      const u = uRaw ? JSON.parse(uRaw) : null;
      if (t) setToken(t);
      if (u) setUser(u);
    } catch {}
    setLoading(false);
  }, []);

  // Persiste cada cambio
  useEffect(() => {
    if (token) localStorage.setItem("token", token);
    else localStorage.removeItem("token");
  }, [token]);

  useEffect(() => {
    if (user) localStorage.setItem("user", JSON.stringify(user));
    else localStorage.removeItem("user");
  }, [user]);

  // Login: pega a tu API y guarda token/usuario
  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    
    setToken(data.token);
    setUser(data.user || {});
    return data;
  };

  // Logout: limpia todo
  const logout = () => {
    setToken(null);
    setUser(null);
  };

  const value = useMemo(
    () => ({
      loading,
      isAuth: !!token,
      token,
      user,
      login,
      logout,
    }),
    [loading, token, user]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}
